import React from "react";
import { useDocumentMeta } from "./hooks/useDocumentMeta";
import { SiteHeader } from "./components/SiteHeader";
import { SiteFooter } from "./components/SiteFooter";
import { MiniLeadForm } from "./components/MiniLeadForm";

const Terms = () => {
  useDocumentMeta({
    title: "Terms of Use | PickQuick",
    description:
      "Terms governing use of the letspickquick.com website, content ownership, the illustrative nature of case study numbers, and how revenue commitments are handled.",
    ogType: "website",
    ogUrl: "https://letspickquick.com/terms",
    canonical: "https://letspickquick.com/terms",
  });

  return (
    <div className="min-h-screen flex flex-col" style={{ background: "var(--bg-deep)", color: "#FFFFFF" }}>
      <SiteHeader />

      <main className="flex-1 py-24" data-testid="terms-page">
        <div className="container" style={{ maxWidth: "780px" }}>
          <h1 style={{ fontSize: "44px", fontWeight: 700, lineHeight: 1.15, letterSpacing: "-0.02em", marginBottom: "16px" }}>
            Terms of Use
          </h1>
          <p style={{ color: "#8A8A8A", fontSize: "14px", marginBottom: "48px" }}>
            Last updated: April 2026
          </p>

          <div style={{ color: "#B8B8B8", fontSize: "16px", lineHeight: 1.7 }}>
            <p style={{ marginBottom: "24px" }}>
              These terms govern your use of the letspickquick.com website and the information presented on it. By accessing or using the site you agree to these terms.
            </p>

            <h2 style={{ fontSize: "22px", fontWeight: 600, color: "#FFFFFF", marginTop: "40px", marginBottom: "12px" }}>Content ownership</h2>
            <p style={{ marginBottom: "24px" }}>
              All content on letspickquick.com, including copy, images, diagrams, brand marks, code, and design elements, is the property of PickQuick or its licensors. You may not reproduce, distribute, or create derivative works from this content without prior written permission.
            </p>

            <h2 style={{ fontSize: "22px", fontWeight: 600, color: "#FFFFFF", marginTop: "40px", marginBottom: "12px" }}>No warranty on projections or figures</h2>
            <p style={{ marginBottom: "24px" }}>
              Any performance figures, revenue references, case study numbers, growth projections, or category benchmarks presented on this site are illustrative. PickQuick does not warrant their accuracy, completeness, or applicability to any specific brand or category. Past performance of one brand does not indicate the future performance of another.
            </p>

            <h2 style={{ fontSize: "22px", fontWeight: 600, color: "#FFFFFF", marginTop: "40px", marginBottom: "12px" }}>Revenue commitments</h2>
            <p style={{ marginBottom: "24px" }}>
              Any revenue baseline, minimum revenue commitment, or written guarantee mentioned anywhere on this website is contractual only under a signed agreement between PickQuick and the brand in question. Nothing on this website, including but not limited to headlines, case studies, testimonials, or FAQ answers, constitutes a binding offer, quotation, or commitment of any kind.
            </p>

            <h2 style={{ fontSize: "22px", fontWeight: 600, color: "#FFFFFF", marginTop: "40px", marginBottom: "12px" }}>Third-party links</h2>
            <p style={{ marginBottom: "24px" }}>
              This site may link to third-party services (booking tools, blog platforms, messaging apps). PickQuick is not responsible for the content, availability, or privacy practices of those third parties.
            </p>

            <h2 style={{ fontSize: "22px", fontWeight: 600, color: "#FFFFFF", marginTop: "40px", marginBottom: "12px" }}>Governing law and jurisdiction</h2>
            <p style={{ marginBottom: "24px" }}>
              These terms are governed by the laws of India. Any dispute arising from or in connection with this website or its content is subject to the exclusive jurisdiction of the courts of Mumbai.
            </p>

            <h2 style={{ fontSize: "22px", fontWeight: 600, color: "#FFFFFF", marginTop: "40px", marginBottom: "12px" }}>Contact</h2>
            <p style={{ marginBottom: "24px" }}>
              Questions about these terms: <a href="mailto:anuj@letspickquick.com" style={{ color: "#F1592B" }}>anuj@letspickquick.com</a>
            </p>
          </div>
        </div>
      </main>

      <section className="pb-16" style={{ backgroundColor: "var(--bg-deep)" }}>
        <div className="container" style={{ maxWidth: "1080px" }}>
          <MiniLeadForm
            source="terms-mini"
            variant="band"
            pagePath="/terms"
            headline="Ready to talk revenue?"
            subhead="Free QC audit. One platform, one category, no cost. We open WhatsApp with your details pre-filled."
          />
        </div>
      </section>

      <SiteFooter />
    </div>
  );
};

export default Terms;
